import { render, staticRenderFns } from "./CategoryPhotos.vue?vue&type=template&id=3c7923bc&"
import script from "./CategoryPhotos.vue?vue&type=script&lang=js&"
export * from "./CategoryPhotos.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPhotos.vue?vue&type=style&index=0&id=3c7923bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports